import { initMixpanel } from '@/renderer/utils/stat/mixp';

export default function onAfterRenderClient(_pageContext: Vike.PageContext) {
  initMixpanel(); // this will process the queue up to now

  //   MixpanelProxy.track_pageview();
}
